/**
 * @Description: ""
 * @Author: YOYO [792611446@qq.com]
 * @LastEditors:   YOYO [792611446@qq.com]
 * @Date:   2020-08-20 17:52:02
 * @LastEditTime: 2020-11-17 16:09:43
 */
// import { formatDateTime } from '@/utils/objectUtil'
import echarts from 'echarts'

export const OPTION = {
  tooltip: {},
  grid: {
    top: 30,
    left: 44,
    bottom: 56,
  },
  // legend: {
  //   top: 15,
  //   data: ['加速度'],
  //   textStyle: {
  //     color: '#fff',
  //   },
  // },
  xAxis: {
    data: [],
    // data: (function () {
    //   var now = new Date()
    //   var res = []
    //   var len = 100
    //   while (len--) {
    //     res.unshift(formatDateTime(now, 'HH:mm:ss'))
    //     now = new Date(now - 2000)
    //   }
    //   return res
    // })(),
    axisLine: {
      lineStyle: {
        color: '#999',
      },
    },
    axisTick: {
      show: false,
    },
    axisPointer: {
      show: true,
    },
    axisLabel: {
      rotate: 40,
      // interval: 5,
    },
  },
  yAxis: {
    type: 'value',
    position: 'left',
    // name: 'g',
    // nameLocation: 'end',
    splitLine: {
      show: false,
    },
    axisTick: {
      show: false,
    },
    // nameTextStyle: {
    //   color: '#ffac53',
    //   fontSize: 14,
    //   fontWeight: 'bold',
    //   align: 'left',
    // },
    axisLine: {
      lineStyle: {
        color: '#999',
      },
    },
    axisLabel: {
      show: false,
    },
    max: 16,
    splitNumber: 5,
  },
  series: [
    {
      data: [],
      // data: (function () {
      //   var res = []
      //   var len = 100
      //   while (len--) {
      //     res.push(Math.round(Math.random() * 41 + 200))
      //   }
      //   return res
      // })(),
      name: '加速度',
      type: 'line',
      symbol: 'circle',
      symbolSize: 1,
      lineStyle: {
        color: '#ffac53',
        width: 2,
      },
      itemStyle: {
        color: '#ffac53',
      },
      smooth: true,
    },
  ],
}
export const OPTIONBAR = {
  tooltip: {
    trigger: 'axis',
  },
  grid: {
    top: 50,
    left: 44,
    bottom: 52,
  },
  legend: {
    top: 5,
    data: ['告警次数', '告警设备数'],
    itemWidth: 12,
    itemHeight: 15,
    icon: 'rect',
    // top: -3,
    // orient: 'vertical',
    // right: 10,
    textStyle: {
      color: '#B3B5B8',
    },
  },
  xAxis: {
    data: [],
    axisLine: { lineStyle: { color: '#1D4366' } },
    axisTick: { show: false },
    axisLabel: {
      rotate: 40,
      color: '#eee',
    },
  },
  yAxis: [
    {
      type: 'value',
      position: 'left',
      // name: '',
      // nameTextStyle: {
      //   color: '#00AEFF',
      //   fontSize: 12,
      //   align: 'left',
      // },
      axisLine: { lineStyle: { color: '#1D4366' } },
      axisTick: { show: false },
      axisLabel: { color: '#eee' },
      splitLine: { show: false },
    },
    // {
    //   type: 'value',
    //   position: 'left',
    //   name: '数量',
    //   nameTextStyle: {
    //     color: '#2BD7E7',
    //     fontSize: 12,
    //     align: 'left',
    //   },
    //   axisLine: { lineStyle: { color: '#1D4366' } },
    //   axisTick: { show: false },
    //   axisLabel: { color: '#eee' },
    //   splitLine: { show: false },
    //   position: 'right',
    // }
  ],
  series: [
    {
      data: [],
      name: '告警次数',
      type: 'bar',
      barWidth: 13,
      barGap: 0.2,
      itemStyle: {
        color: new echarts.graphic.LinearGradient(
          0, 0, 0, 1,
          [
            { offset: 0.58, color: '#00AEFF' },
            { offset: 1, color: 'rgba(0,0,0,0)' },
          ]
        ),
      },
    },
    {
      data: [],
      name: '告警设备数',
      type: 'bar',
      barWidth: 13,
      // yAxisIndex: 1,
      itemStyle: {
        color: new echarts.graphic.LinearGradient(
          0, 0, 0, 1,
          [
            { offset: 0.58, color: '#2BD7E7' },
            // {offset: 0.9, color: 'rgba(0,0,0,0)'},
            { offset: 1, color: 'rgba(0,0,0,0)' },
          ]
        ),
      },
    },
  ],
}

// 地图 瞭望者marker windowinfo 中 实时数据配置
export const realTimeOption = {
  color: ['#f91b26', '#ffca28', '#4dd292'],
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      show: true,
    },
  },
  grid: {
    x: 50,
    y2: 30,
  },
  legend: {
    data: ['最高车速', '平均车速', '车流量'],
    textStyle: {
      color: '#fff',
    },
  },
  xAxis: [
    {
      type: 'category',
      data: [],
      axisPointer: {
        type: 'shadow',
      },
      axisLine: {
        lineStyle: {
          color: '#fff',
        },
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      name: '车辆速度(km/h)',
      axisLabel: {
        fhormatter: '{value} km/h',
        color: '#fff',
      },
      nameTextStyle: {
        color: '#fff',
      },
      axisLine: {
        lineStyle: {
          color: '#fff',
        },
      },
    },
  ],
  series: [
    {
      name: '最高车速',
      type: 'line',
      data: [],
    },
    {
      name: '平均车速',
      type: 'line',
      data: [],
    },
    {
      name: '车流量',
      type: 'line',
      data: [],
    },
  ],
}

// 哨兵二代 marker windowinfo 中 数据配置
export const historyOption = {
  tooltip: {
    trigger: 'axis',
    axisPointer: {
      show: true,
    },
  },
  grid: {
    x: 45,
    y2: 40,
  },

  legend: {
    data: [],
    textStyle: {
      color: '#fff',
    },
  },
  xAxis: [
    {
      axisLabel: {
        color: '#fff',
      },
      type: 'category',
      data: [],
      axisPointer: {
        type: 'shadow',
      },
      axisLine: {
        lineStyle: {
          color: '#fff',
        },
      },
    },
  ],
  yAxis: [
    {
      type: 'value',
      name: '加速度 (m/s²)',
      axisLabel: {
        fhormatter: '{value} m/s²',
        color: '#fff',
      },
      nameTextStyle: {
        color: '#fff',
      },
      axisLine: {
        lineStyle: {
          color: '#fff',
        },
      },
    },
  ],
  series: [
    {
      name: 'x加速度',
      type: 'line',
      data: [],
    },
    {
      name: 'y加速度',
      type: 'line',
      data: [],
    },
    {
      name: 'z加速度',
      type: 'line',
      data: [],
    },
  ],
  color: ['red', 'yellow', 'green' ]
}
